import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Link, CardTitle } from '@one-thd/sui-atomic-components';

const ListHeader = ({ name, url, itemCount, hideSubHeader = false, disableLink = false }) => (
  <CardTitle
    header={(
      <Typography lineClamp="2" decoration={disableLink ? null : 'underline'} component="h3" height="normal">
        {!disableLink ? (
          <Link
            href={url}
            color="primary"
            className="sui-text-base @2xl:sui-text-lg sui-text-primary !sui-font-bold !sui-capitalize sui-break-all"
          >
            {name}
          </Link>
        ) : (
          <span className="sui-text-base @2xl:sui-text-lg sui-text-primary !sui-font-bold !sui-capitalize sui-break-all">
            {name}
          </span>
        )}
      </Typography>
    )}
    subheader={!hideSubHeader ? (
      <span className="sui-hidden @sm:sui-flex">
        {`Total Items: ${itemCount}`}
      </span>
    ) : null}
  />
);

ListHeader.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string,
  itemCount: PropTypes.number.isRequired,
  hideSubHeader: PropTypes.bool,
  disableLink: PropTypes.bool
};

export default ListHeader;